import { render, staticRenderFns } from "./companyDynamic.vue?vue&type=template&id=2c3d4456&scoped=true&"
import script from "./companyDynamic.vue?vue&type=script&lang=js&"
export * from "./companyDynamic.vue?vue&type=script&lang=js&"
import style0 from "./companyDynamic.vue?vue&type=style&index=0&id=2c3d4456&lang=scss&scoped=true&"
import style1 from "./companyDynamic.vue?vue&type=style&index=1&id=2c3d4456&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2c3d4456",
  null
  
)

export default component.exports